import './Nutrition.css';

const Nutrition = () => {
    return (
        <div className="nutrition-page">
            <div className="nutrition-container">
                <h1>Nutrition Information</h1>
                <p>Learn about the nutritional content of our products.</p>
            </div>
        </div>
    );
};

export default Nutrition;